import ResumenDiario from './ResumenDiario';
export const Dashboard = () => <ResumenDiario />;
export default Dashboard;
